import React, {Fragment} from 'react';
import {Dialog, Transition} from '@headlessui/react';
import {connect} from 'react-redux';
import * as Actions from '../store/actions';
import {X} from 'lucide-react';

function Example({
  children,
  show = false,
  onClose,
  extraModalClasses = '',
  extraModalClassesStart = '',
  modalBg = 'bg-white',
  modalPosition = 'items-center justify-center',
  modalPadding = 'p-2',
  modalTitle,
  modalTitleIcon,
  modalTitleBadge,
  enterFrom,
  modalSubTitle,
  leaveFrom,
  leaveTo,
  changeLookupPage,
  // noBottomPadding = false,
  borderRadius = 'rounded-lg',
  pointerEventsNone,
  overlayBackground = '',
  hideOnSmallerDevices,
  customHeadingSize = false,
  noHidden,
  // contentPadding = 'p-6',
}) {
  const subDomainUser = localStorage.getItem('subdomain');
  const isProfiledRisk = subDomainUser?.includes('profiledrisk');

  return (
    <Transition.Root show={show} as={Fragment}>
      <Dialog
        as="div"
        className={`fixed inset-0 z-40 ${
          hideOnSmallerDevices ? 'hidden md:block' : ''
        } ${isProfiledRisk ? 'font-sans' : ''}`}
        onClose={() => {
          changeLookupPage(1);
          onClose();
        }}
      >
        <div
          className={`flex ${modalPosition} ${modalPadding} ${
            overlayBackground
              ? 'bg-[#0F0F19] bg-opacity-70 backdrop-blur-sm'
              : ''
          } text-center h-full `}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay
              className={`fixed inset-0 transition-opacity bg-black bg-opacity-25 ${
                pointerEventsNone ? 'pointer-events-none' : ''
              } `}
            />
          </Transition.Child>

          <span aria-hidden="true">&#8203;</span>
          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-500"
            enterFrom={`${
              enterFrom
                ? enterFrom
                : 'opacity-0 translate-y-20 sm:translate-y-0 sm:translate-x-20'
            }`}
            enterTo="opacity-100 translate-y-0 sm:translate-y-0 sm:translate-x-0 sm:scale-100"
            leave="ease-out duration-300"
            leaveFrom={`${
              leaveFrom
                ? leaveFrom
                : 'opacity-100 translate-y-0 sm:translate-x-0 sm:scale-100'
            }`}
            leaveTo={`${
              leaveTo
                ? leaveTo
                : 'opacity-0 translate-y-20 sm:translate-y-0 sm:translate-x-20 sm:scale-95'
            }`}
          >
            <div
              className={` ${extraModalClassesStart} inline-block  ${
                noHidden ? '' : 'overflow-hidden'
              }  w-full ${
                modalBg === 'bg-transparent' ? '' : 'shadow-xl bg-white'
              } ${borderRadius} transition-all transform sm:p-0 sm:w-full ${extraModalClasses}`}
            >
              {modalTitle ? (
                <>
                  <div>
                    <header className="flex items-center bg-[#F9F9F9] justify-between py-3 px-6 rounded-t-xl border-[0.5px] border-transparent border-b-[#EFEFEF]">
                      <div className="flex items-center gap-2">
                        {modalTitleIcon}
                        <h3
                          className={`font-semibold text-deepBlue ${
                            customHeadingSize ? 'text-lg' : 'text-[18px]'
                          }`}
                        >
                          {modalTitle}
                        </h3>

                        {/* ← NEW BADGE */}
                        {modalTitleBadge && (
                          <div className="py-0.5 px-2 flex items-center justify-center bg-[#F0FFFE] rounded-full text-[#127D78] text-xs font-medium">
                            {modalTitleBadge}
                          </div>
                        )}
                      </div>
                      <button
                        onClick={() => {
                          changeLookupPage();
                          onClose(false);
                        }}
                        className="bg-[#EDEDED] rounded-md p-1.5"
                      >
                        <X size={16} color="#242424" />
                      </button>
                    </header>
                    {modalSubTitle && (
                      <p className="px-6 text-[#344272] text-start text-sm font-normal py-2 mt-2 border-[0.5px] border-transparent border-b-[#EFEFEF]">
                        {modalSubTitle}
                      </p>
                    )}
                    <div>{children}</div>
                  </div>
                </>
              ) : (
                children
              )}
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export default connect(null, Actions)(Example);
